import { Component, OnInit, inject } from '@angular/core';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { Store, select } from '@ngrx/store';

import { Observable } from 'rxjs';

import { selectCurrentTab } from './store/selectors/my-advertisements.selector';
import { Tabs } from '../dashboard/components/overview/models/overview.model';

@Component({
  selector: 'app-my-advertisements',
  templateUrl: './my-advertisements.component.html',
  styleUrls: ['./my-advertisements.component.scss'],
  standalone: false,
})
export class MyAdvertisementsComponent implements OnInit {
  private readonly store = inject(Store);

  pageTitle$ = this.store.pipe(select(SiteSelectors.selectPageTitle));
  tabs = Tabs;
  currentTab$: Observable<Tabs>;

  ngOnInit() {
    this.store.dispatch(
      SiteActions.updatePageTitle({ pageTitle: 'Mestplace - Mijn advertenties' }),
    );

    this.currentTab$ = this.store.pipe(select(selectCurrentTab));
  }
}
